import { useState } from "react";
import Reveal from "@/components/base/Reveal";

const FAQS = [
  {
    q: "Vocês fazem manutenção de motores elétricos?",
    a: "Sim. Realizamos manutenção de motores elétricos industriais, incluindo serviços preventivos e corretivos.",
  },
  {
    q: "É possível recuperar um motor queimado?",
    a: "Depende da condição do motor. Em muitos casos é possível recuperar com rebobinamento ou outros procedimentos. Uma avaliação técnica identifica a viabilidade.",
  },
  {
    q: "Vocês atendem motores industriais?",
    a: "Sim, atendemos motores industriais de diversos portes e aplicações.",
  },
  {
    q: "Vocês vendem motores elétricos?",
    a: "Sim, trabalhamos com fornecimento de motores elétricos. Consulte a disponibilidade e o modelo adequado à sua aplicação.",
  },
  {
    q: "Trabalham com motores recondicionados?",
    a: "Sim, oferecemos motores recondicionados como alternativa com bom custo-benefício, conforme disponibilidade.",
  },
  {
    q: "Como saber se devo reparar ou substituir o motor?",
    a: "A decisão depende do custo, da condição do motor e da aplicação. Uma avaliação técnica ajuda a comparar as opções.",
  },
  {
    q: "Como solicitar orçamento?",
    a: "Você pode enviar uma mensagem pelo WhatsApp ou preencher o formulário de contato com as informações do equipamento.",
  },
  {
    q: "Posso enviar fotos pelo WhatsApp?",
    a: "Sim. Enviar fotos do equipamento e da etiqueta de identificação ajuda na avaliação.",
  },
  {
    q: "Quais regiões vocês atendem?",
    a: "Atendemos a região Sul (PR, SC, RS), Sudeste (SP, RJ, MG, ES) e Centro-Oeste (MT, MS, GO, DF).",
  },
  {
    q: "Existe garantia?",
    a: "As condições de garantia variam conforme o serviço ou produto. Consulte nossa equipe para informações específicas.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-3xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Perguntas frequentes
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-center text-base text-foreground-600">
            Respostas diretas para as dúvidas mais comuns sobre motores e assistência técnica.
          </p>
        </Reveal>

        <div className="mt-10 space-y-3">
          {FAQS.map((faq, i) => {
            const open = openIndex === i;
            return (
              <Reveal key={faq.q} delay={i * 30}>
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-semibold text-foreground-900">{faq.q}</span>
                    <i
                      className={`text-xl text-primary-600 transition-transform duration-200 ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    />
                  </button>
                  {open && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}